<template>
    <div>

        <confirmation-modal v-model="deleteModal" :item="item" @accept="deleteItem"
            :message="$t('delete_element_confirm')" />
        <edit-expense-item v-model="editModal" :item="item" @update="onUpdate" />
        <base-sidebar :isOpen.sync="value" :title="$t('edit') | capitalize" size="md">
            <template v-slot:body>
                        {{  preExpense.loadOrder.comments }}
                <vs-row class="mb-4">
                    <vs-col class="px-2" vs-w="6">
                        <vs-input :label="$t('no_order') | capitalize" :placeholder="$t('no_order') | capitalize"
                            v-model="preExpense.loadOrder.no_order" class="w-full" disabled />
                    </vs-col>
                    <vs-col class="px-2" vs-w="6">
                        <vs-input :label="$t('folio') | capitalize" :placeholder="$t('folio') | capitalize"
                            v-model="preExpense.loadOrder.folio" class="w-full" disabled />
                    </vs-col>
                </vs-row>

                <vs-row class="mb-4">
                    <vs-col vs-w="6" class="px-2">
                        <vs-input :label="$t('iva') | upperCase" :placeholder="$t('iva') | upperCase" value="0%"
                            class="w-full" disabled />
                    </vs-col>
                    <vs-col vs-w="6" class="px-2">
                        <vs-input :label="$t('currency') | capitalize" :placeholder="$t('currency') | capitalize"
                            value="USD" class="w-full" disabled />
                    </vs-col>
                </vs-row>
                <vs-row class="mb-4">
                    <vs-col class="px-2" vs-w="6">
                        <vs-input :label="$t('pallets') | capitalize" :placeholder="$t('quantity') | capitalize"
                            v-model="preExpense.loadOrder.quantity" class="w-full" disabled />
                    </vs-col>
                </vs-row>
                <vs-row class="mb-4">
                    <vs-col class="px-4" vs-w="12">
                        <label>{{ $t('comments') | capitalize }}</label>
                    </vs-col>
                    <vs-col class="px-2" vs-w="12">
                        <vs-textarea v-model="comments" class="no-resize" />
                    </vs-col>
                </vs-row>
                <vs-row class="mb-4">
                    <vs-col class="px-2">
                        <expense-items :items="containers" :total="total" @edit="onEdit" @delete="onDelete" />
                    </vs-col>
                </vs-row>
            </template>
            <template v-slot:footer>
                <vs-button color="danger" icon="cancel" type="flat" @click="$emit('input', false)">{{ $t('cancel')
                }}</vs-button>

                <vs-button color="success" icon="save" type="flat" @click="save">{{ $t('save')
                }}</vs-button>
            </template>
        </base-sidebar>
    </div>
</template>
<script setup>
import { ref, computed, watch } from 'vue'
import BaseSidebar from '@/views/app/components/BaseSidebar.vue';
import ConfirmationModal from '@/views/app/components/ConfirmationModal.vue'
import EditExpenseItem from './EditExpenseItem.vue'
import ExpenseItems from './ExpenseItems.vue'

const props = defineProps({
    value: { type: Boolean, default: false },
    isOpen: { type: Boolean, default: false },
    pallets: { type: Object, default: () => ({}) },
    preExpense: { type: Object, default: () => ({}) }
})

const deleteModal = ref(false)
const editModal = ref(false)
const item = ref({})
const containers = ref([])
const comments = ref('')

const emit = defineEmits(['save'])

watch(() => props.value, (newValue) => {
    if (newValue) {
        containers.value = [...props.preExpense.containers]
        comments.value = props.preExpense.loadOrder.comments
    }
})

const total = computed(() => containers.value.reduce((acc, obj) => {
    return obj.active == 1
        ? acc + (Number(obj.total) || 0)
        : acc;
}, 0))

const onEdit = (row) => {
    item.value = { ...row }
    editModal.value = true
}

const onDelete = (row) => {
    item.value = { ...row }
    deleteModal.value = true
}

const deleteItem = () => {
    const find = containers.value.find(el => el.id === item.value.id);
    deleteModal.value = false
    if (find) {
        find.active = false
    }
}

const onUpdate = (row) => {
    const find = containers.value.find(el => el.id === row.id);
    if (find) {
        find.quantity = row.quantity
        find.unit_price = row.unitPrice
        find.total = row.total
    }
    editModal.value = false
}

const save = () => {
    const data = {
        id: props.preExpense.loadOrder.id,
        total: total.value,
        containers: { ...containers.value },
        comments: comments.value
    }
    emit('save', data)
}

</script>

<style>
.no-resize textarea {
    resize: none;
}
</style>
